var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-kpi"},_vm._l((_vm.kpis),function(kpi){return _c('div',{key:kpi.order,staticClass:"device-kpi__item",style:(("color: " + (kpi.color)))},[_vm._v(" "+_vm._s(kpi.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }